















































import { FTextField, FFormStep, FForm, FLoader } from '@fkui/vue';
import Vue from 'vue';
import { ValidationService } from '@fkui/logic';
import { AnsokanService } from '@/services/AnsokanService';
import { fmiPersistenceService } from '@/storage';
import { scrollTo, focus } from '@fkui/logic';

export default Vue.extend({
    name: 'Ansokan',
    components: { FTextField, FFormStep, FForm, FLoader },

    data() {
        return {
            pnr: '',
            storage: fmiPersistenceService,
            inflight: false,
            pnrElement: (null as unknown) as HTMLElement | null,
        };
    },

    computed: {
        isDirty(): boolean {
            return ValidationService.isAnyTouched;
        },
    },

    methods: {
        async laggTillValideringEventlyssnare() {
            this.pnrElement = this.$el.querySelector<HTMLElement>('#giltigt-pnr');
            if (this.pnrElement !== null) {
                this.pnrElement.addEventListener('component-validity', this.fokuseraPaFel);
            }
        },

        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        async fokuseraPaFel(event: any) {
            if (!event.detail.isValid) {
                await this.$nextTick();
                const felyta = this.$el.querySelector<HTMLElement>('div.form-step__error');
                if (felyta !== null) {
                    scrollTo(felyta);
                    focus(felyta);
                }
                if (this.pnrElement !== null) {
                    this.pnrElement.removeEventListener('component-validity', this.fokuseraPaFel);
                }
            }
        },
        async onSubmit(): Promise<void> {
            const bestall = (): void => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const pnrOk = !(this.$refs.form as any).hasError;
                if (pnrOk && !this.inflight) {
                    this.inflight = true;

                    const ansokan = {
                        pnr: this.pnr,
                        date: new Date().toISOString().substring(0, 10),
                    };
                    AnsokanService.submit(ansokan)
                        .then(() => {
                            // Application was submitted OK, go to signing SP
                            this.inflight = false;
                            this.storage.set(ansokan);
                            this.$router.push({
                                name: 'Kvittens',
                            });
                        })
                        .catch(() => {
                            this.inflight = false;
                            this.$router.push({
                                name: 'teknisktfel',
                            });
                        });
                }
            };
            setTimeout(bestall, 200);
        },
    },
});
